import {useState, useEffect} from 'react';

import PharmaorderEditFormImpl from '../../PharmaorderEditFormImpl';
import PharmaorderEditFormOnly from 'components/pharmaorder/PharmaorderEditFormOnly';
export default function EditorderActionImpl(){

    return (
        // <PharmaorderEditFormImpl/>
        <PharmaorderEditFormOnly/>
    )
}